<template>
  <v-dialog v-model="open" max-width="420" persistent transition="dialog-bottom-transition">
    <v-card :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'">
      <v-card-title class="px-4 pt-4">{{ titleText }}</v-card-title>

      <v-card-text class="px-4 pb-0">
        <div v-if="needsVerification">
          Please verify your {{ missingWhat }} to continue.
        </div>
        <div v-else-if="needsLiveAccount">
          Please create a live trading account before Deposit/Withdraw.
        </div>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer />
        <v-btn class="elevation-0" :color="$vuetify.theme.dark ? '#FF567F' : '#FF567F'" @click="primaryAction">
          {{ primaryLabel }}
        </v-btn>
        <v-btn outlined class="elevation-0" @click="open = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'VerifyGateDialog',

  data: () => ({
    open: false,
    fetched: false, // wait for Vuex data before deciding
  }),

  computed: {
    ...mapState('profile', {
      verifications: s => s.verifications || { identity: 0, resident: 0, liveAccounts: 0 },
    }),

    isIdentityVerified() { return Number(this.verifications.identity) === 1 },
    
    isResidentVerified() { return Number(this.verifications.resident) === 1 },

    needsVerification() { return !this.isIdentityVerified || !this.isResidentVerified },

    needsLiveAccount() {
      return this.isIdentityVerified && this.isResidentVerified &&
             Number(this.verifications.liveAccounts || 0) <= 0
    },

    shouldShow() { return this.needsVerification || this.needsLiveAccount },

    missingWhat() {
      if (!this.isIdentityVerified && !this.isResidentVerified) return 'Identity & Residency'
      if (!this.isIdentityVerified) return 'Identity'
      if (!this.isResidentVerified) return 'Residency'
      return ''
    },

    titleText() {
      return this.needsVerification ? 'Please Verify Your Profile' : 'Action Required'
    },

    primaryLabel() {
      return this.needsVerification ? 'Verify Profile' : 'Create Live Account'
    },
  },

  watch: {
    verifications: { deep: true, handler() { this.maybeOpen() } },
  },

  methods: {
    ...mapActions('profile', ['POPUPNOTICE']),

    maybeOpen() {
      if (!this.fetched) return
      this.open = !!this.shouldShow
    },

    primaryAction() {
      if (this.needsVerification) this.$router.push('/profile-verify')
      else if (this.needsLiveAccount) this.$router.push('/create-live-account')
      this.open = false
    },
  },

  async created() {
    await this.POPUPNOTICE()
    this.fetched = true
    this.maybeOpen()
  },
}
</script>
